import * as React from 'react';
import { makeStyles, shorthands } from '@fluentui/react-components';

export enum StatusTabEnum{
    Loading,
    AccessDenied,
    OldVersionFromCache,
}

export interface StatusTabProps {
    MsgId: StatusTabEnum;
}

const useStyles = makeStyles({
    root: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        ...shorthands.gap("20px"),
    },
});

export const StatusTab: React.FC<StatusTabProps> = ({ MsgId }) => {
    const styles = useStyles();
    if (MsgId === StatusTabEnum.Loading) {
        return (
            <div className={styles.root}>
                <h1>Neomytic</h1>
                <h2>Loading...</h2>
            </div>
        );
    }
    return (
        <div className={styles.root}>
            <h1>Neomytic</h1>
            <h2>Access to the admin site is not allowed.</h2>
        </div>
    );
};